import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'

import Table from '@aytm/app/stats/components/data-views/table/components/Table'
import { calcMdsItemsListProps } from '@aytm/app/stats/page/question-views/bpm/components/mds/lib/table-utils'

const MdsTable = ({ id, answer, questionVariants, batches, chartLegendMode, mdsBrandsValue }) => {
  const { cols, rows } = calcMdsItemsListProps({
    id,
    answer,
    questionVariants,
    batches,
    mdsBrandsValue,
    chartLegendMode
  })

  return <Table cols={cols} rows={rows} />
}

MdsTable.displayName = 'BpmMdsTable'

MdsTable.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  answer: answerPropType,
  questionVariants: PropTypes.array,
  batches: PropTypes.array,
  chartLegendMode: PropTypes.string,
  mdsBrandsValue: PropTypes.array
}

export default MdsTable
